<div class="header">
    <h2>{{ 'quizzes.modal.view.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="quizzes-view-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

@if (loading() !== false) {
    <div class="loading">
        <i class="pi pi-spin pi-spinner"></i>
    </div>
} @else if (error()) {
    <app-unavailable [message]="'quizzes.error.unavailable' | translate" />
} @else if (quiz(); as quiz) {
    <div class="body">
        <div class="section">
            <h2>{{ 'quizzes.fieldset.basic' | translate }}</h2>
            <div class="field">
                <span class="label">{{ 'quizzes.form.name' | translate }}</span>
                <span class="value">{{ quiz.name || '-' }}</span>
            </div>
        </div>

        <div class="section">
            <h2>{{ 'quizzes.questions.title' | translate }}</h2>
            <app-entity-list [ids]="questionIds()" type="quiz-question" emptyKey="quizzes.questions.empty" />
        </div>
    </div>

    <div class="footer">
        <app-delete-button [quizId]="quiz.id" [saving]="saving()" testId="quizzes-view-delete" />
        <p-button [label]="'quizzes.detail.edit' | translate" icon="pi pi-pencil" data-test="quizzes-view-edit" (onClick)="onEdit()" />
    </div>
}
